import { useTranslation } from "react-i18next";
import { Box, Divider, Typography } from "@mui/material";

import { Chat } from "../../../types/chat";

import { ChatItem, ChatItemLoader } from "./ChatItem";

const ChatSideBarChatList = ({
  chats,
  isChatLoading,
  ownUserId,
  onChatSelect,
}: {
  chats: Chat[];
  isChatLoading: boolean;
  ownUserId: number;
  onChatSelect?: () => void;
}) => {
  if (isChatLoading) return <ChatListLoading />;
  if (!isChatLoading && chats.length === 0) return <EmptyChatList />;
  return <ChatListContent chats={chats} ownUserId={ownUserId} onChatSelect={onChatSelect} />;
};

export default ChatSideBarChatList;

const EmptyChatList = () => {
  const { t } = useTranslation("chat");

  return <Typography sx={styles.emptyChatList}>{t("youDontHaveAnyChats")}</Typography>;
};

const ChatListLoading = () => {
  return (
    <Box sx={styles.chatListContent}>
      {Array.from({ length: 5 }).map((_, index) => (
        <>
          <ChatItemLoader key={index} />
          {index !== 4 && <Divider />}
        </>
      ))}
    </Box>
  );
};

const ChatListContent = ({
  chats,
  ownUserId,
  onChatSelect,
}: {
  chats: Chat[];
  ownUserId: number;
  onChatSelect?: () => void;
}) => {
  return (
    <Box sx={styles.chatListContent}>
      {chats.map((chat, index) => (
        <>
          <ChatItem key={chat.id} chat={chat} ownUserId={ownUserId} onChatSelect={onChatSelect} />
          {index !== chats.length - 1 && <Divider />}
        </>
      ))}
    </Box>
  );
};

const styles = {
  emptyChatList: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    textAlign: "center",
  },
  chatListContent: {
    display: "flex",
    flexDirection: "column",
    gap: "17px",
    overflowY: "auto",
    flex: 1, // Take remaining space in flex container
    minHeight: 0, // Allow flex shrinking
    paddingRight: "10px",
    // Add scrollbar styling for better mobile experience
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#a8a8a8",
    },
  },
};
